import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M15.5 2.5L17.5 4.5C17.8946 4.89464 18.1054 5.50536 17.8946 5.89464L16.8946 6.89464L13.1054 3.10536L14.1054 2.10536C14.4946 1.89464 15.1054 2.10536 15.5 2.5ZM12.5 5.5L3.5 14.5V17.5H6.5L15.5 8.5L12.5 5.5Z",
      fill: "#c2a788"
    }, null, -1)
  ]))]))
}
export default { render: render }